var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("URL: "+_vm._s(_vm.redirectUrl))]),_c('p',[_vm._v("TYPE: "+_vm._s(_vm.type))]),_vm._v(" ANIMACJA LOGOWANIA ")])}
var staticRenderFns = []

export { render, staticRenderFns }